import { render, staticRenderFns } from "./food_tags.page.vue?vue&type=template&id=babf524c&"
import script from "./food_tags.page.vue?vue&type=script&lang=js&"
export * from "./food_tags.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports